export default [
    { 
        text    : 'id', 
        value   : 'id',
        width   : '5%',
    },
    { 
        text    : 'nombre', 
        value   : 'name',
        sortable: true,
        width   : '20%',
    },
    { 
        text    : 'producto', 
        value   : ({ wh_product }) => wh_product.name,
        width   : '20%',
    },
    {
        text    : 'UPC',
        value   : ({ wh_product }) => wh_product.upc_codes.slice().shift(),
    },
    { 
        text    : 'precio oferta', 
        value   : 'offer_price',
        width   : '10%',
        align   : 'center',
        format  : 'currency',
    },
    { 
        text    : 'fecha de inicio', 
        value   : 'init_datetime',
        width   : '10%',
        align   : 'right',
        format  : 'date',
    },
    { 
        text    : 'fecha de termino', 
        value   : 'finish_datetime',
        width   : '10%',
        align   : 'right',
        format  : 'date',
    },
]